import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { logOut } from 'actions/authentication';
import { GET_STARTED_SCHEDULING_URL } from 'util/urls';

export function NavbarItems({ blackVariant }) {
  const { token } = useSelector((state) => state.user);

  const itemClass = `mini-navbar-items-item ${
    blackVariant ? 'mini-navbar-items-item--black' : ''
  }`;
  return (
    <div className="flex-row mini-navbar-items">
      {token ? (
        <>
          <Link className={`${itemClass} button`} to="/services">
            Profile
          </Link>
          <button className={`${itemClass} button`} onClick={() => logOut('/')}>
            Log out
          </button>
        </>
      ) : (
        <>
          <Link className={itemClass} to="/login">
            Log in
          </Link>
          <Link className={itemClass} to="/signup">
            Sign up
          </Link>
          <a
            href={GET_STARTED_SCHEDULING_URL}
            target="_blank"
            className={`${itemClass} button`}
            rel="noreferrer"
          >
            Get started
          </a>
        </>
      )}
    </div>
  );
}
